$(document).ready(function () {
  const user = Ingtech.user;
  const client = Ingtech.client;
  if (!user || !client) return;

  const _hsq = (window._hsq = window._hsq || []);

  _hsq.push([
    "identify",
    {
      id: user.id,
      email: user.email,
      username: user.username,
      firstName: user.firstName,
      lastName: user.lastName,
      clientId: client.id,
      clientName: client.name,
    },
  ]);
});
